
export default {
	name: 'currency',
	handler: {
		symbol: ko.observable('R'),
		update: function (element, valueAccessor, allBindingsAccessor) {
			return ko.bindingHandlers.text.update(element, function () {
				let value = +(ko.utils.unwrapObservable(valueAccessor()) || 0);
				let symbol = null;

				if (ko.utils.unwrapObservable(allBindingsAccessor().symbol) === undefined)
					symbol = ko.bindingHandlers.currency.symbol();
				else
					symbol = ko.utils.unwrapObservable(allBindingsAccessor().symbol);

				return symbol + value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
			});
		}
	}
};
